import { Component, OnInit } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { AppContext } from "src/app/ui/contexts/app-context";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { PageableResult } from "src/app/ui/models/domains/paginator/pageable-result";
import { PagingRequest } from "src/app/ui/models/domains/paginator/paging-request";
import { FileBeneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/file-beneficiary";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { ICompanyFilterParams } from "src/app/ui/models/domains/pbm/companies/company-filter-params";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { LoadingService } from "src/app/ui/services/loading.service";
import { BeneficiaryService } from "src/app/ui/services/pbm/beneficiary.service";
import { CompanyService } from "src/app/ui/services/pbm/company.service";
import { UserService } from "src/app/ui/services/user.service";
import { Toast } from "../../../toast/toast";
import { HttpErrorResponse } from "@angular/common/http";
import { ImportBeneficiaryResult } from "src/app/ui/models/domains/pbm/Beneficiary/import-beneficiary-result";

@Component({
  selector: "block-beneficiaries",
  templateUrl: "./block-beneficiaries.component.html",
  styleUrls: ["./block-beneficiaries.component.scss"],
})
export class BlockBeneficiariesComponent implements OnInit {
  filesInput: FileList;
  fileName: string;
  company: Company;
  filterText: string;
  fileBeneficiary = new FileBeneficiary();
  searchNotFound = false;
  searchActionFired = false;
  fiscalNumberMask = MaskInput.getFicalNumberMask();
  searchType: UntypedFormControl;

  private searchCompanyFirst: boolean;
  public companyPageableResult = new PageableResult();
  private userProfile = this.userService.getUserProfile();

  constructor(
    private featureViewService: FeatureViewService,
    private beneficiaryService: BeneficiaryService,
    private loadingService: LoadingService,
    private companyService: CompanyService,
    private toast: Toast,
    private userService: UserService,
    private appContext: AppContext,
  ) {
    this.searchType = new UntypedFormControl(1);
  }

  ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.BeneficiaryBlockBeneficiariesFeatureView, PageViews.BeneficiaryPageView);
    this.userProfile = this.userService.getUserProfile();
    if (this.userProfile.getPreferences().getFilterText()) {
      this.searchCompanies(this.userProfile.getPreferences().getFilterText());
    } else {
      this.searchCompanies("");
    }
  }

  async searchCompany(company: Company) {
    if (company.getFiscalNumber()) {
      const ref = this.loadingService.beginLoading();
      try {
        this.company = await this.companyService.findCompanyBy(company.getFiscalNumber());
        this.fileBeneficiary.setFiscalNumber(company.getFiscalNumber());
        this.searchNotFound = false;
        this.storageSearchPreferences(company.getFiscalNumber());
      } catch (error) {
        this.company = null;
        this.searchNotFound = true;
        this.toast.showWarningToast(error);
        this.storageSearchPreferences(null);
      } finally {
        this.loadingService.finishLoading(ref);
        this.filterText = "";
      }
    } else {
      this.company = null;
      this.searchNotFound = true;
      //this.storageSearchPreferences(company.getFiscalNumber());
      this.filterText = "";
    }
  }

  getFile(event) {
    const files = event.target.files;
    if (!FileBeneficiary.isCsvExtension(files.item(0))) {
      this.toast.showWarningToast("Insira um arquivo .csv");
    } else {
      const file = files.item(0);
      this.filesInput = files;
      this.fileName = file.name;
      this.fileBeneficiary.setFile(file);
    }
    event.target.value = null;
  }
  importBeneficiaryResult: ImportBeneficiaryResult
  async uploadFile() {
    if (this.fileBeneficiary.hasFile()) {
      const ref = this.loadingService.beginLoading();
      try {
        const importBeneficiaryResult = await this.beneficiaryService.importBlockCardNumber(this.fileBeneficiary);
        this.importBeneficiaryResult = new ImportBeneficiaryResult([]);
        this.toast.showSuccessToast('Beneficiários bloqueados com sucesso');
      } catch (result) {
        this.importBeneficiaryResult = result
        this.toast.showWarningToast('Erro ao bloquear beneficiários');
      } finally {
        this.filesInput = null;
        this.fileName = null;
        this.fileBeneficiary.setFile(null);
        this.loadingService.finishLoading(ref);
      }
    } else {
      this.toast.showWarningToast("Insira um arquivo .csv");
    }
  }

  hasCompany(): boolean {
    return !!this.company;
  }

  onPressEnterSearchCompanies(event): void {
    if (event.key === "Enter") this.searchCompanies(this.filterText);
  }

  searchCompanies(filterText: string) {
    const start = 1;
    const end = this.appContext.getTotalPerPage();
    this.searchCompanyFirst = true;
    this.doSearchCompany(start, end, filterText);
  }

  searchMoreCompanies() {
    this.searchCompanyFirst = false;
    const start = this.companyPageableResult.getEnd() + 1;
    const end = this.appContext.getTotalPerPage();
    this.doSearchCompany(start, end, this.userProfile.getPreferences().getFilterText());
  }

  private doSearchCompany(start: number, end: number, filterText: string): void {
    const ref = this.loadingService.beginLoading();
    const pagingRequest = new PagingRequest();
    pagingRequest.setStart(start);
    pagingRequest.setEnd(end);

    const filterParams: ICompanyFilterParams = {
      filterText: filterText ? filterText.replace(/[./-]/g, "") : "",
    };
    this.companyService
      .searchCompany(filterParams, pagingRequest)
      .then((companyPageableResult) => {
        this.companyPageableResult.setStart(start);
        this.companyPageableResult.setEnd(end);
        this.companyPageableResult.setTotalItems(companyPageableResult.getTotalItems());

        if (this.searchCompanyFirst) {
          this.companyPageableResult.setItems(companyPageableResult.getItems());
        } else {
          this.companyPageableResult.addItems(companyPageableResult.getItems());
        }

        if (companyPageableResult.getItems().length === 1) {
          this.company = companyPageableResult.getItems().find((x) => x !== undefined) as Company;
          this.searchCompany(this.company);
          this.storageSearchPreferences(filterText);
        } else {
          this.company = null;
          this.storageSearchPreferences(null);
        }
      })
      .catch((error) => {
        this.companyPageableResult.setItems(null);
        this.storageSearchPreferences(null);
      })
      .finally(() => {
        this.loadingService.finishLoading(ref);
        //this.storageSearchPreferences(filterText);
        this.filterText = "";
      });
  }

  showScrollBottomBtn(): boolean {
    return this.companyPageableResult.getItems().length > 1;
  }

  showMoreCompaniesBtn(): boolean {
    return this.companyPageableResult.getTotalItems() !== this.companyPageableResult.getItems().length && this.companyPageableResult.getItems().length > 1;
  }

  storageSearchPreferences(fiscalNumber): void {
    this.userService.setUserPreferences(fiscalNumber ? fiscalNumber.replace(/[./-]/g, "") : fiscalNumber);
  }

  scrollToLastCompany() {
    const bottom = document.getElementById("bottom");
    bottom.scrollIntoView();
  }
}
